(function () {
  var STORAGE_KEY = 'eros.drawer.restore.v1';
  var TTL_MS = 30 * 60 * 1000;
  var MOBILE_MQ = window.matchMedia('(max-width: 699px)');

  var sidebar = document.getElementById('sidebar-menu');
  if (!sidebar) return;

  var restoreScheduled = false;

  function collapsiblePanel() {
    return sidebar.querySelector('[slot="collapsible-panel"]');
  }

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function isBackForwardNavigation() {
    var entries = performance.getEntriesByType && performance.getEntriesByType('navigation');
    var nav = entries && entries[0];
    return !!(nav && nav.type === 'back_forward');
  }

  function isHubNavigationLink(anchor) {
    if (!anchor.closest('#eros-drawer-panel-collections, [id^="eros-drawer-panel-cat-"]')) {
      return false;
    }

    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#') {
      return false;
    }

    try {
      var url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) {
        return false;
      }
      return url.pathname.indexOf('/collections/') !== -1 || url.pathname !== window.location.pathname;
    } catch (error) {
      return false;
    }
  }

  function resolveActivePanelId(anchor) {
    var panel = collapsiblePanel();
    if (panel) {
      var active = panel.getAttribute('aria-activedescendant');
      if (active) {
        return active;
      }
    }

    var subPanel = anchor ? anchor.closest('.header-sidebar__sub-panel[id]') : null;
    return subPanel ? subPanel.id : null;
  }

  function saveRestoreState(panelId) {
    if (!panelId || !isMobile()) {
      return;
    }

    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ panelId: panelId, ts: Date.now() })
      );
    } catch (error) {
      /* ignore quota / privacy mode */
    }
  }

  function loadRestoreState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) {
        return null;
      }

      var data = JSON.parse(raw);
      if (!data || !data.panelId || !data.ts) {
        return null;
      }

      if (Date.now() - data.ts > TTL_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return data;
    } catch (error) {
      return null;
    }
  }

  function clearRestoreState() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      /* ignore */
    }
  }

  function syncMainPanelExpanded(panelId) {
    var targetControls = null;
    if (panelId === 'eros-drawer-panel-products' || panelId.indexOf('eros-drawer-panel-cat-') === 0) {
      targetControls = 'eros-drawer-panel-products';
    } else if (panelId === 'eros-drawer-panel-collections') {
      targetControls = 'eros-drawer-panel-collections';
    }

    sidebar.querySelectorAll('.header-sidebar__main-panel .header-sidebar__linklist [aria-controls]').forEach(function (button) {
      var isTarget = targetControls && button.getAttribute('aria-controls') === targetControls;
      button.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
    });
  }

  function waitForSidebarReady() {
    if (typeof sidebar.show === 'function') {
      return Promise.resolve();
    }

    return customElements.whenDefined('header-sidebar').then(function () {
      return undefined;
    });
  }

  function restoreDrawerPanel(panelId) {
    if (!panelId || !sidebar.querySelector('#' + CSS.escape(panelId))) {
      return Promise.resolve(false);
    }

    return waitForSidebarReady().then(function () {
      if (typeof sidebar.show !== 'function') {
        return false;
      }

      var openSidebar = sidebar.open ? Promise.resolve() : sidebar.show();
      return openSidebar.then(function () {
        var panel = collapsiblePanel();
        if (!panel) {
          return false;
        }

        // sidebar.show() (via HeaderSidebar's onSidebarAfterShow/revealItems
        // in theme.js) always leaves .header-sidebar__main-panel fully
        // visible (opacity 1) — it has no idea we're about to jump straight
        // to a sub-panel. In the normal interactive flow, a real click on a
        // main-panel button runs openCollapsiblePanel_fn, which explicitly
        // fades the main panel out (opacity 0, translateX(-10px)) on mobile
        // before the collapsible panel takes over. Restoring via
        // aria-activedescendant alone bypasses that click handler entirely,
        // so without this the main panel and the restored sub-panel end up
        // simultaneously visible, overlapping — confirmed live.
        //
        // revealItems() is triggered independently by the same
        // dialog:after-show event our own show() call fires, and applies
        // its opacity:1 asynchronously (Motion One timeline) — a plain
        // synchronous hide here loses that race (confirmed live: opacity
        // ended back at "1" moments after this ran first). Re-applying
        // across the next two animation frames wins deterministically
        // without needing to know exactly when Motion One schedules its
        // own write.
        // Deliberately only opacity/transform (not pointer-events) — this
        // matches exactly what openCollapsiblePanel_fn does on the real
        // click path, which theme.js's own revealItems()/closePanel_fn
        // already knows how to reverse cleanly when the user backs out to
        // the main panel. Adding anything revealItems() doesn't also reset
        // (e.g. pointer-events) would leak past that point.
        // Two rAF frames were NOT enough in practice (confirmed live —
        // inline opacity still ended up back at "1" after that window), so
        // rather than guess at a frame count or timeout that happens to
        // outlast Motion One's actual scheduling, watch the panel's style
        // attribute directly and re-correct on every write for a bounded
        // window, then stop — deterministic regardless of exact timing.
        var mainPanel = sidebar.querySelector('.header-sidebar__main-panel');
        if (mainPanel) {
          var hideMainPanel = function () {
            mainPanel.style.opacity = '0';
            mainPanel.style.transform = 'translateX(-10px)';
          };
          hideMainPanel();

          var guarding = true;
          var observer = new MutationObserver(function () {
            if (!guarding) return;
            if (mainPanel.style.opacity !== '0') {
              hideMainPanel();
            }
          });
          observer.observe(mainPanel, { attributes: true, attributeFilter: ['style'] });
          window.setTimeout(function () {
            guarding = false;
            observer.disconnect();
          }, 1000);
        }

        syncMainPanelExpanded(panelId);
        panel.setAttribute('aria-activedescendant', panelId);
        return true;
      });
    });
  }

  function scheduleRestore(fromBackForward) {
    if (!fromBackForward || !isMobile() || restoreScheduled) {
      return;
    }

    var data = loadRestoreState();
    if (!data) {
      return;
    }

    restoreScheduled = true;

    restoreDrawerPanel(data.panelId).then(function (ok) {
      if (ok) {
        clearRestoreState();
      }
      restoreScheduled = false;
    });
  }

  sidebar.addEventListener(
    'click',
    function (event) {
      var anchor = event.target.closest('a[href]');
      if (!anchor || !isHubNavigationLink(anchor)) {
        return;
      }

      var panelId = resolveActivePanelId(anchor);
      if (panelId) {
        saveRestoreState(panelId);
      }
    },
    true
  );

  window.addEventListener('pageshow', function (event) {
    if (event.persisted || isBackForwardNavigation()) {
      scheduleRestore(true);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (isBackForwardNavigation()) {
        scheduleRestore(true);
      }
    });
  } else if (isBackForwardNavigation()) {
    scheduleRestore(true);
  }
})();
